import { useContext, useState, useEffect } from 'react'
import '../css/document/docdel.css'
import { Dimcontext } from '../../context/pagecontext'
import { Button, Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap'
import { MdClose, MdWarningAmber } from 'react-icons/md'
import api from '../../api'
import Swal from 'sweetalert2'
import { ToastContainer,Zoom,toast } from 'react-toastify'
import { Datacontext } from '../../context/dataContext'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../firebase'

export const Docdel = ({set_del, id, docg}) => {
    const {setDim} = useContext(Dimcontext)
    const [doc, setdoc] = useState({})
    const [docname, setdocname] = useState('')
    const { docs } = useContext(Datacontext)
    const navigate = useNavigate()

    const handledelclose = () => {
        set_del(false)
        setDim(false)
    }

    const showToast = (msg) => 
    toast.warn(msg, {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Zoom,
    });

    

    useEffect(() => { const getdel = async(id) => {
        const d= docs.find(item => item.id === id);
            setdoc(d)
    }
    getdel(id) }, [id,docs])

    const del = async(e) => {
        e.preventDefault()
        // Standardize comparison to avoid space/case issues
        if (doc.doc_Name?.trim().toLowerCase() !== docname.trim().toLowerCase()) {
            return showToast("Document name does not match!");
        }
        
        try {
            await api.delete(`/del_Document/${id}`)
            Swal.fire({
                title: "Deleted!",
                text: "The document has been removed successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true 
            });
            setDim(false)
            set_del(false)
            docg()
        } catch (err) { console.error(err); 
                    if (err.response && err.response.status === 401) {
                        showToast("Session expired. Attempting to refresh...");
                        try {
                            // Force Firebase to get a fresh token
                            const freshToken = await auth.currentUser.getIdToken(true);
                            sessionStorage.setItem("token", freshToken);
                            // OPTIONAL: Retry the failed request with the freshToken
                            // return retryRequest(originalConfig, freshToken);
                        } catch (refreshErr) {
                            // If refreshing fails, the user session is truly dead
                            showToast("Refresh failed. Logging out.");
                            navigate("/")
                            
                            // window.location.href = '/login'; 
                        }
                    } else {
                        // Handle other types of errors (Network, 500, etc.)
                        showToast("Something went wrong. Please try again.");
                    } }
    }

    return (
        <div className="del-modal-container shadow-lg">
            <ToastContainer/>
            <div className="del-header">
                <div className="d-flex align-items-center gap-2">
                    <MdWarningAmber className="text-danger" size={24} />
                    <h4 className="m-0 text-danger">Confirm Deletion</h4>
                </div>
                <Button onClick={handledelclose} className='btn-close-custom'><MdClose/></Button>
            </div>
            
            <div className="del-body p-4">
                <p className="text-muted mb-4">
                    This action is permanent. Please type <strong>{doc.doc_Name}</strong> below to confirm.
                </p>
                
                <Form onSubmit={del}>
                    <FormGroup className="mb-3">
                        <FormLabel className="fw-bold small text-uppercase">Document to Remove</FormLabel>
                        <FormControl 
                            readOnly
                            className="bg-light border-dashed"
                            value={doc.doc_Name || ''}
                        />
                    </FormGroup>

                    <FormGroup className="mb-4">
                        <FormLabel className="fw-bold small text-uppercase text-danger">Verification</FormLabel>
                        <FormControl 
                            required
                            autoFocus
                            value={docname}
                            onChange={(e) => setdocname(e.target.value)}
                            placeholder='Type document name here...'
                        />
                    </FormGroup>

                    <div className="d-flex gap-2 justify-content-end">
                        <Button variant="light" onClick={handledelclose}>Cancel</Button>
                        <Button variant="danger" type='submit' className="px-4">Delete Permanently</Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}